/**
 * Event listener for handling dynamic import errors in Vite
 * This helps catch and handle chunk loading failures gracefully
 * ref.: https://vite.dev/guide/build#load-error-handling
 */

export const MAX_RELOAD_ATTEMPTS = 3;
export const EVENT_KEY = 'vite_reload_count';

export const eventHandler = (event: Event) => {
  const reloadCount = parseInt(sessionStorage.getItem(EVENT_KEY) || '0');

  // Prevent infinite reload loops in the same session (max 3 attempts)
  if (reloadCount < MAX_RELOAD_ATTEMPTS) {
    // By calling preventDefault, the import error will not be thrown
    event.preventDefault();
    sessionStorage.setItem(EVENT_KEY, String(reloadCount + 1));
    window.location.reload();
    return;
  }
};

window.addEventListener('vite:preloadError', eventHandler);
